var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3161 4.11278L16.8489 2.56591C17.514 1.8947 18.5924 1.8947 19.2575 2.56591C19.9226 3.23712 19.9226 4.32538 19.2575 4.99659L9.61225 14.7303C9.13203 15.215 8.53974 15.5712 7.88887 15.7669L5.4501 16.5L6.17656 14.0389C6.37044 13.382 6.72344 12.7843 7.20365 12.2997L15.3161 4.11278ZM15.3161 4.11278L17.7126 6.53124M16.3501 12.8333V17.1875C16.3501 18.3266 15.4351 19.25 14.3063 19.25H4.76885C3.64012 19.25 2.7251 18.3266 2.7251 17.1875V7.56249C2.7251 6.4234 3.64012 5.49999 4.76885 5.49999H9.08343",
    stroke: "#120A8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.92a1195fe858c9275c19b2ba263cf65a.svg";
export { ForwardRef as ReactComponent };